module.exports = __webpack_public_path__ + "img/sld_scb_11_t1_b1_dark.e5927a29.svg";